"use client";

import { BrandType } from "@/app/types/brand";
import { Divider } from "@mui/material";
import AdminBarSetter from "@v2/components/adminBar/AdminBarSetter";
import RecordView from "@v2/components/RecordView";
import PdpNoSsrSidebarSkeletons from "./PdpNoSsrSidebarSkeletons";
import PdpOperations from "./PdpOperations";
import PdpPickableOptions from "./PdpPickableOptions";
import PdpSizeHelper from "./PdpSizeHelper";
import { usePdpVariant } from "./PdpVariantContext";
import { variantPickerAxes } from "../utils";

type Props = {
    brand: BrandType;
    isTriable: boolean;
    siteProductId: number;
    siteProductSlug: string;
    siteProductTitle: string;
};

export default function PdpSidebarVariant({
    brand,
    isTriable,
    siteProductId,
    siteProductSlug,
    siteProductTitle,
}: Props) {
    const { showProduct, details, variantAxes, mounted } = usePdpVariant();

    // The "same colour in other sizes" hints only know colour and size. With more
    // than one axis to choose they count the wrong variants, so they stay hidden
    // and the picker fades the values that would end out of stock instead.
    const multiAxis = (variantPickerAxes(showProduct, details, variantAxes) ?? [])
        .filter(axis => axis.values.length > 1).length > 1;
    const inStockProducts = multiAxis ? []
        : details.filter(p => p.is_available !== false && p.quantity > 0 && p.final_price > 0);

    if (!mounted) return <PdpNoSsrSidebarSkeletons />;

    return (
        <>
            <AdminBarSetter actions={[
                { label: "ویرایش محصول درحال نمایش", href: `${process.env.NEXT_PUBLIC_PORTAL_URL}/product/list/${showProduct.product_id}` },
                { label: "ویرایش محصول سایت", href: `${process.env.NEXT_PUBLIC_PORTAL_URL}/product/site/${siteProductId}` },
            ]} />
            <RecordView entity="site_product" id={siteProductId} />
            <RecordView entity="product" id={showProduct.product_id} />
            <PdpPickableOptions />
            <PdpSizeHelper />
            <Divider sx={{ mt: 3, mb: 2 }} />
            <PdpOperations
                showProduct={showProduct}
                brand={brand}
                isTriable={isTriable}
                inStockProducts={inStockProducts}
                extra={{
                    siteProductId,
                    siteProductSlug,
                    siteProductTitle,
                    isFavorite: false,
                }}
            />
        </>
    );
}
